import { PermissionsState } from './types';
import { RootState } from 'store/root-reducer';
import { createSelector } from '@reduxjs/toolkit';

const selectPermissionsReducer = (state: RootState): PermissionsState => state.permissions;

export const selectPermissionCodes = createSelector(
  [selectPermissionsReducer],
  (permissions) => permissions.permissionCodes
);

export const selectPermissionsInitialized = createSelector(
  [selectPermissionsReducer],
  (permissions) => permissions.permissionsInitialized
);

export const selectPermissionsError = createSelector([selectPermissionsReducer], (permissions) => permissions.error);

export const selectLoading = createSelector([selectPermissionsReducer], (permissions) => permissions.loading);

export const selectAllShowBooks = createSelector([selectPermissionsReducer], (permissions) => permissions.allShowBooks);

export const selectUpdateFullBook = createSelector(
  [selectPermissionsReducer],
  (permissions) => permissions.updateFullBook
);

export const selectUpdateCompanyName = createSelector(
  [selectPermissionsReducer],
  (permissions) => permissions.updateCompanyName
);
